import { RichTextBaseExtensions } from '@framework/form';
import { ComputeExpressionReferenceNode } from '../../schema/expressions/compute/input/nodes/ComputeExpressionReferenceNode';
import { TooltipVirtualNode } from './render/nodes/TooltipVirtualNode';

export const RichTextAdvancedExtensions = [
  ComputeExpressionReferenceNode.configure({}),
];

export const RichTextAdvancedRenderingExtensions = [
  ...RichTextBaseExtensions,
  ...RichTextAdvancedExtensions,
  TooltipVirtualNode,
];
